import script from "./TestTaker.vue?vue&type=script&setup=true&lang=js"
export * from "./TestTaker.vue?vue&type=script&setup=true&lang=js"

import "./TestTaker.vue?vue&type=style&index=0&id=17eab445&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17eab445"]])

export default __exports__